import { stripNonDigits } from '@/shared/lib/format-utils';

const EXTENSION = /(?<=\d)\s*\(?\s*(?:ext(?:n|ension)?\.?|x|#|[,;]).*$/i;
// E.164 allows at most 15 digits; below 7 there is no local number to dial.
const MIN_DIGITS = 7;
const MAX_DIGITS = 15;

/** `(309) 249-2342 ext 15` → `3092492342`; `+1 309 249 2342` → `+13092492342`. `null` when the
 * value holds no plausible number, so a caller never builds an empty or merged `tel:` link. */
export function getDialablePhone(value: string): string | null {
    const trimmed = value.trim();
    const digits = stripNonDigits(trimmed.replace(EXTENSION, ''));

    if (digits.length < MIN_DIGITS || digits.length > MAX_DIGITS) return null;

    return trimmed.startsWith('+') ? `+${digits}` : digits;
}
